import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { CancelOrderButton } from '../../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import IncrementButton from '../../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import { EditableTableField } from '../../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import style from '../../IndividualTacticStyle.module.css';

export const AddToWinnerTacticPanelRows = observer(
  ({ qtyBasis, qtyBasisArr, breakPricesArr, tradePlanId }) => {
    const [addQtyBasisValue, setAddQtyBasisValue] = useState();
    const [addBreakPriceValue, setAddBreakPriceValue] = useState();

    const updateTactic = (details) => {
      updatePlugins('tactic', details, 'ADD_TO_WINNER', tradePlanId, null);
    };
    return (
      <tbody>
        {qtyBasisArr.map((value, index) => {
          return (
            <tr key={value + breakPricesArr[index]}>
              <td className={style.labelTd}>
                <Body3 fontWeight={700} color={colors.lightGrey}>
                  {index + 1}
                </Body3>
              </td>
              <td className={style.inputTd}>
                <div className={style.inputWrapper}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    {qtyBasis === 'QUANTITY' ? '#' : '$'}
                  </Body3>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={value}
                    updateValue={(newValue) => {
                      const qtyBasisArrCopy = [...qtyBasisArr];
                      qtyBasisArrCopy[index] = newValue;
                      updateTactic({
                        quantityBasisValues: qtyBasisArrCopy,
                        breakPrices: breakPricesArr,
                      });
                    }}
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </div>
              </td>
              <td className={style.labelTd}>
                <div className={style.inputWrapper}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    $
                  </Body3>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={breakPricesArr[index]}
                    updateValue={(newValue) => {
                      const breakPricesArrCopy = [...breakPricesArr];
                      breakPricesArrCopy[index] = newValue;
                      updateTactic({
                        breakPrices: breakPricesArrCopy,
                        quantityBasisValues: qtyBasisArr,
                      });
                    }}
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </div>
              </td>
              <td className={style.inputTd}>
                <div className={style.inputWrapper}>
                  <CancelOrderButton
                    margin="5px 0 0 0"
                    width={15}
                    clickHandler={() => {
                      const filteredBreakPricesArrCopy = [
                        ...breakPricesArr,
                      ].filter((value, i) => i !== index);
                      const filteredQtyBasisArrCopy = [...qtyBasisArr].filter(
                        (value, i) => i !== index
                      );
                      updateTactic({
                        breakPrices: filteredBreakPricesArrCopy,
                        quantityBasisValues: filteredQtyBasisArrCopy,
                      });
                    }}
                  />
                </div>
              </td>
            </tr>
          );
        })}
        <tr>
          <td className={style.labelTd}>
            <Body3 fontWeight={700} color={colors.lightGrey}>
              Add
            </Body3>
          </td>
          <td className={style.inputTd}>
            <div className={style.inputWrapper}>
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                {qtyBasis === 'QUANTITY' ? '#' : '$'}
              </Body3>
              <EditableTableFieldNoOnBlurUpdate
                value={addQtyBasisValue}
                setValue={setAddQtyBasisValue}
                color={colors.lightGrey}
                fontSize="0.694rem"
                inputType="number"
                backgroundColor="inherit"
              />
            </div>
          </td>
          <td className={style.labelTd}>
            <div className={style.inputWrapper}>
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                $
              </Body3>
              <EditableTableFieldNoOnBlurUpdate
                value={addBreakPriceValue}
                setValue={setAddBreakPriceValue}
                color={colors.lightGrey}
                fontSize="0.694rem"
                inputType="number"
                backgroundColor="inherit"
              />
            </div>
          </td>
          <td className={style.inputTd}>
            <div className={style.inputWrapper}>
              <IncrementButton
                margin="3px 0 0 0"
                paddingPercent={10}
                color={colors.white}
                backgroundColor={colors.blue}
                width={15}
                stroke={2}
                handleClick={() => {
                  const breakPricesArrCopy = [...breakPricesArr];
                  const qtyBasisArrCopy = [...qtyBasisArr];
                  breakPricesArrCopy.push(addBreakPriceValue);
                  qtyBasisArrCopy.push(addQtyBasisValue);
                  updateTactic({
                    breakPrices: breakPricesArrCopy,
                    quantityBasisValues: qtyBasisArrCopy,
                  });
                }}
              />
            </div>
          </td>
        </tr>
      </tbody>
    );
  }
);
AddToWinnerTacticPanelRows.propTypes = {
  breakPricesArr: PropTypes.any,
  qtyBasis: PropTypes.string,
  qtyBasisArr: PropTypes.shape({
    map: PropTypes.func,
  }),
  tradePlanId: PropTypes.any,
};
